import { ApiService } from 'src/app/api.service';
import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchComponent } from '../search/search.component';
import { MenuMobileComponent } from './../menu-mobile/menu-mobile.component';
import { Router } from '@angular/router';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  categories: any;
  subCategories: any;
  subSubCategorie: any;
  subcategorieReports: any[]= []
  constructor(private matDialog: MatDialog, private apiService: ApiService, private router: Router) { }

  ngOnInit(): void {
    this.loadCategories();

  }

 loadCategories(){
    this.apiService.loadCategories().then((result => {
      this.categories = result
    this.categories.sort((a: { prioridade: number; nome: string; }, b: { prioridade: number; nome: any; }) => {
      return a.prioridade - b.prioridade || a.nome.localeCompare(b.nome);
    });
  }))
  }


  showSubcategory(show: boolean, category: any) {
    this.subSubCategorie = [];
  if (show) {
    this.subCategories = category.categorias;
    this.subCategories.sort((a: { prioridade: number; nome: string; }, b: { prioridade: number; nome: any; }) => {
      return a.prioridade - b.prioridade || a.nome.localeCompare(b.nome);
    });
  } else {
    this.subCategories = [];
  }
}
showReports(show: boolean){
  if(show){
    this.subcategorieReports = [
      {nome: 'Metalúrgica 01/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relatorio+Transparencia+Metal.pdf'},
      {nome: 'Metalúrgica 02/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-02-2024-Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 01/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-032025-Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 02/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+082025+-+Metalu%CC%81rgica.pdf'},
      {nome: 'Metalúrgica 01/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+032026+-+Metalu%CC%81rgica.pdf'},

      {nome: 'Plástico 01/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/relatorio+Transparecncia+Plasticos.pdf'},
      {nome: 'Plástico 02/2024', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-02-2024-Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 01/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio-Transpare%CC%82ncia-032025-Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 02/2025', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+082025+-+Pla%CC%81sticos.pdf'},
      {nome: 'Plástico 01/2026', link: 'https://s3.sa-east-1.amazonaws.com/www.blukit.com.br/assets/leis/Relato%CC%81rio+Transpare%CC%82ncia+032026+-+Plasticos.pdf'}

      
    ]
  } else{
    this.subcategorieReports = [];
  }
}
hideReport(){
  this.subcategorieReports = [];
}
  async checkHasProducts(subcategorias: any){
    if(!subcategorias) return;

    const categoryHasProducts = await Promise.all(subcategorias.map(async (categoria: any) => {
      let products = await this.apiService.getCategoriesWithProductsFiltered(categoria.id);
      if(products.length > 0){
        categoria.hasProducts = true;
        return categoria;
      } else {
        categoria.hasProducts = false;
        return null;
      }
    }));

    return categoryHasProducts.filter(categoria => categoria !== null);
  }

  async showSubSubcategory(show: boolean, subCategory: any){
    if (show && subCategory && subCategory.subcategorias) {
      this.subSubCategorie = await this.checkHasProducts(subCategory.subcategorias);
      this.subSubCategorie.sort((a: { prioridade: number; nome: string; }, b: { prioridade: number; nome: any; }) => {
        return a.prioridade - b.prioridade || a.nome.localeCompare(b.nome);
      });
    } else {
      this.subSubCategorie = [];
    }
  }
  hideCategory(){
    this.subCategories = [];
    this.subSubCategorie = [];
  }

  openModalSearch(){
    document.body.classList.add('no-scroll');
    const dialogRef = this.matDialog.open( SearchComponent, {
      position: {
        top: '0',
        right:'0',
        bottom: '0'
      },
      minHeight: '100%',

    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('no-scroll');
    });
  }

  openModalMenu(){
    document.body.classList.add('no-scroll');
    const dialogRef = this.matDialog.open( MenuMobileComponent, {
    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('no-scroll');
    });
  }
}
